module.exports = __webpack_public_path__ + "static/google-cloud-b27ba2b3ccd7c79ac8bf20984100992d.png";